@if(isDisabled){
<app-loader></app-loader>
}
<div>
    <div class="row">
        <div class="col">
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="isDisabled"
                [routerLink]="isSubContractor ? ['/allocation/postingordersub/add/',0] : ['/allocation/postingorder/add/',0]">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Posting order':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Posting Order
        </div>
        <div class="card-body" style="width: 100%; overflow: auto;">
            <div class="row">
                <div class="col-md-6">
                    <label class="Label">Branch</label>
                    <ng-select name="branch" [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        [(ngModel)]="Filter.BranchId" (change)="ComboLoad('Client')" placeholder="Select Branch">
                    </ng-select>
                </div>

                <div class="col-md-6">
                    <label class="Label">Client</label>
                    <ng-select name="client" [items]="Clients" bindLabel="ClientGroupName"
                        bindValue="ClientGroupMasterID" [(ngModel)]="Filter.ClientId" (change)="ComboLoad('Site')"
                        placeholder="Select Client">
                    </ng-select>
                </div>

                <div class="col-md-6">
                    <label class="Label">Site</label>
                    <ng-select name="site" [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID"
                        [(ngModel)]="Filter.SiteId" placeholder="Select Site">
                    </ng-select>
                </div>

                <div class="col-auto mt-4">
                    <button (click)="this.isSubContractor ? this.SubContractorData() : this.GetData()"
                        class="btn btn-primary btn-sm"> <i class="bi bi-search"></i> Search</button>
                </div>
            </div>
            <div class="mt-4">
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered pt-2"
                    style="width: 100%; overflow: auto;">
                    <thead class="table-light">
                        <tr>
                            <th style="width: 5px;">#</th>
                            <th>Entry No.</th>
                            <th>Employee Code</th>
                            <th>Employee Name</th>
                            <th>Branch Name</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of TableData ;let i = index">
                            <th scope="row">{{ i + 1 }}</th>
                            <td> {{element['TransactionNo']}}</td>
                            <td> {{element['EmpCode']}}</td>
                            <td> {{element['Employee Name']}}</td>
                            <td> {{element['BranchName']}}</td>
                            <td style="width: 5px;">
                                <div class="text-center">
                                    <i class="bi bi-pencil-square text-warning"
                                        [routerLink]=" isSubContractor ? ['/allocation/postingordersub/add/',element['ID']] : ['/allocation/postingorder/add/',element['ID']]">
                                    </i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>&nbsp;&nbsp;
                </div>
            </div>
        </div>
    </div>
</div>